export default "assets/images/text_circle-1befc7d7.png";